import { Spinner, Table } from "react-bootstrap";
import styles from "./index.module.scss";
import { useAppSelector } from "../../../redux/hooks";
import { getSearchProducts } from "../../../redux/selectors";
import useLocalStorageList from "../../../utils/hooks/useLocalStorageList";

const Search = () => {
  const details = useAppSelector((state) => getSearchProducts(state));

  const [cartData, setCartData] = useLocalStorageList("cart", []);
  const addToCart = (product: Object) => {
    setCartData([...cartData, product]);
  };

  if (Object.keys(details).length === 0) {
    return (
      <div className={"container text-center " + styles.loader}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }
  return (
    <div className={styles.search}>
      <div className="container">
        <h5>РЕЗУЛЬТАТЫ ПОИСКА ПО НОМЕРУ ДЕТАЛИ</h5>
        <h2 className="title">Title</h2>
        <div className={styles.table}>
          <Table striped>
            <thead>
              <tr>
                <th>Производитель</th>
                <th>Номер</th>
                <th>Описание</th>
                <th>Цена</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.procedure}>{details?.detailName}</td>
                <td>{details?.vinNumber}</td>
                <td>{details?.catalogType}</td>
                <td className={styles.price}>
                  <span>от</span> {details?.price}
                  <button onClick={() => addToCart(details)}>выбрать</button>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default Search;
